import React, { useMemo } from 'react'
import { Form, Col, Row } from 'react-bootstrap'
import objectPath from 'object-path'
import { getCheckValue } from 'designer/component/action/Data'
import Label from 'designer/component/element/Label'

const CheckboxInputControl = (props) => {
  const { uischema, config, handleChange, path } = props
  const { jsonData } = config
  const { checkboxWidth, input = { name: '', key: '', placeholder: '' } } =
    uischema

  let valueChecked = getCheckValue(uischema.valueChecked)
  let valueUnchecked = getCheckValue(uischema.valueUnchecked)

  let checked = objectPath.get(jsonData, path)
  let inputValue = objectPath.get(jsonData, input.name)

  const updateInput = (value) => {
    handleChange(input.name, value)
  }

  const updateCheckbox = (checked) => {
    let value = checked ? valueChecked : valueUnchecked || null
    handleChange(path, value)
  }

  const styleChange = useMemo(() => {
    let style = {
      width: checkboxWidth ? checkboxWidth : '18px',
      height: checkboxWidth ? checkboxWidth : '18px',
    }
    return style
  }, [checkboxWidth])

  return (
    <Form.Group className="mb-0" controlId={uischema.controlId}>
      <Row className="w-100 mx-0">
        <Label {...props} uischema={uischema} mt={0} />
        <Col sm="auto" className="d-flex align-items-center px-0">
          <Form.Control
            style={styleChange}
            type="checkbox"
            name={uischema.name}
            id={uischema.id}
            checked={checked === valueChecked}
            onChange={(e) => {
              updateCheckbox(e.target.checked)
            }}
          />
        </Col>
        {uischema?.checkboxText && (
          <Label
            {...props}
            uischema={uischema}
            label={uischema.checkboxText}
            onClick={() => {
              let value = checked === valueChecked
              updateCheckbox(!value)
            }}
          />
        )}
        <Col className="pl-0">
          <Form.Control
            type="text"
            name={input.name}
            placeholder={input && input.placeholder}
            autoComplete="off"
            value={inputValue || ''}
            minLength={uischema.minLength}
            maxLength={uischema.maxLength}
            onChange={(e) => {
              updateInput(e.target.value)
            }}
          />
        </Col>
      </Row>
    </Form.Group>
  )
}

export default CheckboxInputControl
